import { render, staticRenderFns } from "./trafficRoute.vue?vue&type=template&id=38301d82&scoped=true&"
import script from "./trafficRoute.vue?vue&type=script&lang=js&"
export * from "./trafficRoute.vue?vue&type=script&lang=js&"
import style0 from "./trafficRoute.vue?vue&type=style&index=0&id=38301d82&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38301d82",
  null
  
)

export default component.exports